import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { format } from "date-fns"

interface useTableColumnsReportesContratosSoftnetProps {
    pagination?: { pageIndex: number; pageSize: number };
}

export const useTableColumnsReportesContratosSoftnet = (props?: useTableColumnsReportesContratosSoftnetProps) => {
    const { pagination } = props || {};

    const columnBase = useMemo<MRT_ColumnDef<any>[]>(() => [
        {
            accessorKey: 'numero',
            header: '#',
            size: 60,
            enableColumnFilter: false,
            Cell: ({ row }) => {
                // Calcular número absoluto basado en la página actual
                const baseNumber = pagination ? (pagination.pageIndex * pagination.pageSize) : 0;
                return baseNumber + row.index + 1;
            },
        },
        {
            accessorKey: 'idContrato',
            header: 'CONTRATO SOFTNET',
            size: 100,
            Cell: ({ cell }) => cell.getValue<number>() || '-',
        },
        {
            accessorKey: 'contratoEva',
            header: 'CONTRATO EVA',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'fechaInstalacion',
            header: 'FECHA INSTALACION',
            size: 150,
            Cell: ({ cell }) => {
                const fecha = cell.getValue() as string;
                if (fecha) {
                    try {
                        return format(new Date(`${fecha}T00:00:00`), 'yyyy-MM-dd');
                    } catch {
                        return fecha;
                    }
                }
                return '-';
            },
        },
        {
            accessorKey: 'fechaSubida',
            header: 'FECHA SUBIDA',
            size: 150,
            Cell: ({ cell }) => {
                const fecha = cell.getValue() as string;
                if (fecha) {
                    try {
                        return format(new Date(`${fecha}T00:00:00`), 'yyyy-MM-dd');
                    } catch {
                        return fecha;
                    }
                }
                return '-';
            },
        },
        {
            accessorKey: 'identificacion',
            header: 'IDENTIFICACION',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombreCliente',
            header: 'NOMBRE CLIENTE',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombreCiudad',
            header: 'NOMBRE CIUDAD',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombrePlan',
            header: 'NOMBRE PLAN',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'areaVentas',
            header: 'AREA VENTAS',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombreVendedor',
            header: 'NOMBRE VENDEDOR',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'detallePago',
            header: 'DETALLE PAGO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombreTecnico',
            header: 'NOMBRE TECNICO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'observacionTecnico',
            header: 'OBSERVACION TECNICO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'observacionVentas',
            header: 'OBSERVACION VENTAS',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'fechaUltimaActualizacion',
            header: 'FECHA ULTIMA ACTUALIZACION',
            size: 100,
            Cell: ({ cell }) => {
                const fecha = cell.getValue() as string;
                if (fecha) {
                    try {
                        return format(new Date(`${fecha}T00:00:00`), 'yyyy-MM-dd HH:mm:ss');
                    } catch {
                        return fecha;
                    }
                }
                return '-';
            },
        },
        {
            accessorKey: 'estadoContratoEva',
            header: 'ESTADO CONTRATO EVA',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'estadoContratoSoftnet',
            header: 'ESTADO CONTRATO SOFTNET',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'estadoServicioSoftnet',
            header: 'ESTADO SERVICIO SOFTNET',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'tipoContrato',
            header: 'TIPO CONTRATO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'formaPago',
            header: 'FORMA DE PAGO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'banco',
            header: 'BANCO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'tipoDescuento',
            header: 'TIPO DESCUENTO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'documentosCargados',
            header: 'DOCUMENTOS CARGADOS',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'existeMigracion',
            header: 'EXISTE MIGRACION',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'revisionMigracion',
            header: 'REVISION MIGRACION',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
    ], [pagination]);

    return {
        columnBase
    }
}
